



























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

export interface DefferedAutocompleteItem {
  id: number;
  text: string;
}

@Component
export default class DeferredAutocomplete extends Vue {
  @Prop() readonly value?: number;
  @Prop() label?: string;
  @Prop() items!: DefferedAutocompleteItem[];
  @Prop({ default: false }) disabled?: boolean;
  @Prop() isLoading?: boolean;
  @Prop() readonly?: boolean;
  @Prop() rules?: ((v: any) => boolean)[];
  @Prop({ default: false }) clearable?: boolean;

  @Prop({ default: false }) outlined?: boolean;
  @Prop({ default: false }) dense?: boolean;
  @Prop({ default: false }) hideDetails?: boolean;

  @Watch("value", { immediate: true })
  async valueChanged(fresh: number) {
    if (fresh) {
      const found = this.items.find((x) => x.id === fresh);
      if (!found) {
        this.$emit("prefill", { id: this.value });
      }
    }
  }

  changed(evt: any) {
    this.$emit("input", evt);
  }

  search = "";
  @Watch("search")
  searchChanged(fresh: string, old: string) {
    if (fresh !== old) {
      this.$emit("search", { search: fresh });
    }
  }
}
